import { Addon } from './addon';
import { ChildModel, ModelBase } from 'store/model-base';

export class AddonCollections extends ModelBase {
    public static storeName: string = 'addonsCollections';
    public addons: Addon[];
    public lineId: string;

    public areValid: boolean;

    public static create<T extends ModelBase>(response: ApiResponse = {}): T {
        response.areValid = response.addons.every((addon: Addon) => Boolean(addon.type && addon.state));

        return super.create<T>(response);
    }

    protected static get hasMany(): ChildModel[] {
        return [{
            attrName: 'addons',
            model: Addon
        }];
    }

    public get hasHdPass(): boolean {
        return this.addons.some((addon: Addon) => addon.isHdPass && addon.isActive);
    }
}
